import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import styled from 'styled-components';

export const SessionConfigInfoText = styled(HBText).attrs({
    type: 'body14',
    color: 'textSecondary'
})``;
